import React from 'react';

/**
 * 클레임 팝업 뷰어용 동영상 전용 영역 (네이티브 video)
 */
export default function ClaimVideoViewer({ videoSrc, fileName, regTime, toolbar }) {
  return (
    <div style={{ display: 'block', minHeight: '70vh' }}>
      {toolbar}
      <ul className="font-bold my-4">
        <li>파일명 : {fileName}</li>
        <li>등록일시 : {regTime?.replace('T', ' ')}</li>
      </ul>
      <div className="flex justify-content-center">
        <video
          src={videoSrc}
          controls
          playsInline
          style={{
            maxHeight: '75vh',
            maxWidth: '960px',
            width: '100%',
          }}
        />
      </div>
    </div>
  );
}
